export class PulumiConfigurations {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "pulumiConfigurations",
            "baseName": "pulumiConfigurations",
            "type": "Array<PulumiConfiguration>",
            "format": ""
        },
        {
            "name": "pagination",
            "baseName": "pagination",
            "type": "Pagination",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return PulumiConfigurations.attributeTypeMap;
    }
    constructor() {
    }
}
